import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useAuth0 } from "@auth0/auth0-react";
import ButtonComponent from "@components/buttonComponent/Button";
import { ContentfulService } from "@services/contentfulService";
import { useRouter } from "next/router";
import { getSaleStage } from "src/utils/isDuringSale";
import { NFTImage } from "./NFTImage";
import styles from "./NFTItem.module.css";
import { CryptoCurrenyCode, useBuyNowBuyerInfoLazyQuery, useGetUsdPriceQuery } from "@graphql-generated";
import { checkAuctionType } from "src/utils/auctionType.utils";
import { getCurrency, getUsdPrice, truncateDecimal } from "src/utils/commonCheck";
import useLocalStorageState from "use-local-storage-state";
import { Network } from "@interface/wallet.interface";
import { LOCAL_STORAGE_STATE } from "src/constants/localStorage";
import { getCardContent } from "src/utils/getCardContent.utils";
import { saleCollection } from "src/enums/saleCollection.enum";
import { convertToEth } from "src/utils/convertToEth.utils";
import * as fbq from '@services/PixelTrack';

interface NFTItemProps {
  title?: String;
  subTitle?: String;
  price?: string;
  saleStart?: String;
  item?: any;
  image?: any;
  isOrder?: boolean;
  isWallet?: boolean;
  handelDetailClick?: any;
  imgURL?: string;
  itemId?: number;
  purchaseDate?: string;
  deatilsForTransfer?: any;
  breadCrumbsName?: string;
  defaultCurrency?: string;
  isSlug?: boolean;
  artistName?: string;
}

export interface CFSItem {
  sys?: Sys;
  total?: number;
  skip?: number;
  limit?: number;
  items?: ItemsEntity[] | null;
  includes?: Includes;
}
export interface Sys {
  type: string;
}
export interface ItemsEntity {
  metadata: Metadata;
  sys: Sys1;
  fields: Fields;
}
export interface Metadata {
  tags?: null[] | null;
}
export interface Sys1 {
  space: SpaceOrEnvironmentOrContentTypeOrImage;
  id: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  environment: SpaceOrEnvironmentOrContentTypeOrImage;
  revision: number;
  contentType: SpaceOrEnvironmentOrContentTypeOrImage;
  locale: string;
}
export interface SpaceOrEnvironmentOrContentTypeOrImage {
  sys: Sys2;
}
export interface Sys2 {
  type: string;
  linkType: string;
  id: string;
}
export interface Fields {
  title: string;
  description: string;
  artist: string;
  tokenId: string;
  tokenStandarad: string;
  network: string;
  contractAddress: string;
  image: SpaceOrEnvironmentOrContentTypeOrImage;
  mojitoItemId: string;
  isReserved: boolean;
  imageUrl: string;
  dimension: string;
  creationDate: string;
  chainId: string;
  metaDataUri: string;
}
export interface Includes {
  Asset?: AssetEntity[] | null;
}
export interface AssetEntity {
  metadata: Metadata;
  sys: Sys3;
  fields: Fields1;
}
export interface Sys3 {
  space: SpaceOrEnvironmentOrContentTypeOrImage;
  id: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  environment: SpaceOrEnvironmentOrContentTypeOrImage;
  revision: number;
  locale: string;
}
export interface Fields1 {
  title: string;
  description: string;
  file: File;
}
export interface File {
  url: string;
  details: Details;
  fileName: string;
  contentType: string;
}
export interface Details {
  size: number;
  image: Image;
}
export interface Image {
  width: number;
  height: number;
}

export interface CollectionPathProps {
  name: string;
  path: string;
}

const NFTItem = ({
  title,
  subTitle,
  price,
  saleStart,
  item,
  image,
  isOrder,
  isWallet,
  handelDetailClick,
  imgURL,
  purchaseDate = "",
  itemId,
  deatilsForTransfer,
  breadCrumbsName,
  defaultCurrency = 'ETH',
  isSlug,
  artistName,
}: NFTItemProps) => {
  const cfs = useMemo(() => {
    return new ContentfulService();
  }, []);
  const router = useRouter();
  const { user } = useAuth0();
  const [storeNetworkDetails, setStoreNetworkDetails] = useLocalStorageState<Network[]>(LOCAL_STORAGE_STATE.secondary_wallet.store_network_details);
  const [cfsItem, setCfsItem] = useState<CFSItem>({});
  const currency = cfsItem?.items ? getCurrency(+cfsItem?.items[0]?.fields?.chainId ?? 0) : CryptoCurrenyCode?.Eth
  const { data: usdPriceData, loading } = useGetUsdPriceQuery({
    variables: {
      cryptoCurrencyCode: currency ?? CryptoCurrenyCode?.Eth
    }
  })
  useEffect(() => {
    if (item?.details?.totalAvailableUnits === 0) {
      buyNowBuyer();
    }
    cfs
      .getLotItem(item?.id)
      .then((res) => {
        if (res.items[0] && res) {
          var respo = res as unknown as CFSItem;
          setCfsItem(respo);
        }
      })
      .catch((err) => {
        console.log("errrr", err);
      });
  }, [item?.id]);
  const [
    buyNowBuyer,
    { data: buyerData, loading: buyerLoading, error: buyuerError },
  ] = useBuyNowBuyerInfoLazyQuery({
    variables: {
      itemId: item?.id || "", // value for 'itemId'
    },
  });
  const saleStage = getSaleStage(item);

  const [arry1, setArr1] = useState("");
  const [arry2, setArr2] = useState("");
  const [arry3, setArr3] = useState("");
  useEffect(() => {
    const arry = title?.split("-");
    if (arry) {
      setArr1(arry[0]);
      setArr2(arry[1]);
      setArr3(arry[2]);
    }
  });

  const getNetworkDetails = storeNetworkDetails?.filter(val => val?.id === item?.details?.marketplaceAuctionOnChainSettings?.networkID);

  const isSoldOut =
    buyerData?.getBuyNowBuyerInfo &&
    buyerData?.getBuyNowBuyerInfo?.length > 0 &&
    item?.details?.totalAvailableUnits === 0;
  const isReserved =
    (cfsItem?.items &&
      cfsItem?.items[0] &&
      cfsItem?.items[0]?.fields?.isReserved) ||
    (item?.details?.totalAvailableUnits === 0 &&
      buyerData?.getBuyNowBuyerInfo?.length === 0);
  const startDate = item?.details?.startDate;
  const endDate = item?.details?.endDate;
  const auctionType = checkAuctionType(startDate, endDate, item?.details?.currentBid?.currentBid);
  const buyNowType = getCardContent(saleStage, isSoldOut ?? false, (breadCrumbsName?.toLowerCase()?.includes(saleCollection?.SUI_SALE) || isSlug ? item?.isReserved : isReserved), item?.details?.startDate);

  const breadCrumbsLabel = useMemo(() => {
    return {
      name: breadCrumbsName ?? 'Project',
      path: String(router.asPath)
    }
  }, [router.asPath]);

  const isOnchainAuction = useMemo(() => !item?.mintOnDemandData && item?.saleType === 'Auction', [item?.mintOnDemandData, item?.saleType]);
  return (
    <div
      className={`${styles.cardwrapper} `}
      onClick={() => {
        fbq.event('View Details', {
          userEmail: user?.email,
          productId: item?.id || itemId,
          productName: item?.name,
          saleType: item?.saleType,
        });
        localStorage.setItem("breadcrumbs", JSON.stringify(breadCrumbsLabel));
        localStorage.setItem("joyDivisionArtist", breadCrumbsName?.includes('Sui') ? breadCrumbsName?.substring(0, 11) : breadCrumbsName?.slice(10,breadCrumbsName?.length)??'');
        if (isWallet) {
          router.push(
            {
              pathname: `/project/nft/${item?.id || itemId}`,
              query: { wallet: true },
            },
            `/project/nft/${item?.id || itemId}`
          );
        } else if (!isOrder) {
          // if (saleStage === "during" && !isReserved && !isSoldOut) {
          // } else {
          // }
          router.push(`/project/nft/${item?.id || itemId}`);
        }
      }}
    >
      <div>
        {imgURL && imgURL !== "" ? (
          <NFTImage height="400px" imgURL={imgURL} />
        ) : image ? (
          <NFTImage height="400px" item={image} />
        ) : (
          <>{cfsItem && cfsItem.items && <NFTImage height="400px" item={cfsItem} />}</>
        )}

        {/* {cfsItem && cfsItem.items && <NFTImage item={cfsItem} />} */}
        {/* <video  
            controls 
            className='img-responsive'
            loop
            muted
            autoplay="autoplay"
            >
              <source src="https://videos.ctfassets.net/2gv2niiq2pbu/k1kG5d2G1aFKXUocHo5T0/1d3a584290fc11ed26449c19a70888ce/_NFT_FUTUR_modify.mp4" />
            </video> */}
      </div>
      <div style={{ padding: '0 20px 16px' }}>
      <h2 className={`${styles.cardHeading} card_title_desk`}>{title}</h2>
      <h2 className={`${styles.cardHeading} card_title_mob`}>
        {arry1} { arry2 ? '-' : ''} <br /> {arry2}{ arry3 ? '-' : ''}{arry3}
      </h2>
      {!isOrder &&
        (subTitle ? (
          <h3 className={styles.contText}>{subTitle}</h3>
        ) : cfsItem && cfsItem.items ? (
              <h3 className={styles.contText}>
                {cfsItem.items[0].fields.artist}
              </h3>
        ): ( 
        <h3 className={styles.contText}>
          { breadCrumbsName?.includes('Sui') ? breadCrumbsName?.substring(0, 11) : !item?.slug?.includes('ghost') && breadCrumbsName?.slice(10,breadCrumbsName?.length) }
        </h3> 
        ))}
      {price ? (
        <Box sx={{ marginY: '10px' }}>
          <Typography fontSize="12px" fontFamily='untitled_sansregular_regular'>PRICE</Typography>
          <p className={styles.priceText}>{defaultCurrency === 'USD' ? `${truncateDecimal(price, 6)} USD` : `${truncateDecimal(price, 6)} ${defaultCurrency}`}</p>
        </Box>
      ) : ((item?.saleType === 'Auction' && cfsItem?.items && !router?.query["slug"]?.includes(saleCollection?.JOY_DIVISION_SALE))||(item?.saleType === 'Auction' && router?.query["slug"]?.includes(saleCollection?.JOY_DIVISION_SALE))) ? (
        <Box sx={{ marginY: '10px' }}>
          <Typography fontSize="12px" fontFamily='untitled_sansregular_regular'>{item?.details?.currentBid?.currentBid ? auctionType?.label : (item?.details?.startingBid && auctionType?.type === 'during_sale') ? 'STARTING BID' : auctionType?.label}</Typography>
          <Box display='flex'>
          <Typography sx={{ fontSize: '20px', fontFamily:'untitled_sansregular_regular' }}>{` ${ item?.details?.currentBid?.currentBid ?? item?.details?.startingBid ?? 0 } ${ isOnchainAuction ? 'ETH' : 'USD'}`}
          </Typography>
          {usdPriceData && (
            <Typography sx={{ color: '#6C717A', fontFamily:'untitled_sansregular_regular', marginLeft: '5px', padding: '10px 0 0 0', fontSize:'12px' }}>{ isOnchainAuction ?  `${getUsdPrice(+usdPriceData?.getUSDPrice?.amount, item?.details?.currentBid?.currentBid ?? item?.details?.startingBid)} USD` : `${ convertToEth(item?.details?.currentBid?.currentBid ?? item?.details?.startingBid,parseInt(usdPriceData?.getUSDPrice?.amount ?? '0'))} ${ !router?.query["slug"]?.includes(saleCollection?.JOY_DIVISION_SALE) &&  cfsItem?.items ? getCurrency(getNetworkDetails?.[0]?.chainID ?? +cfsItem?.items?.[0]?.fields?.chainId):getCurrency(getNetworkDetails?.[0]?.chainID ?? 0) }`}</Typography>
          )}
          </Box>
        </Box>
      ) : (
        <>
          {item && item.details && (
            <Box sx={{ marginY: '10px' }}>
              <Typography fontSize="12px" fontFamily='untitled_sansregular_regular'>PRICE</Typography>
              <Typography sx={{ fontSize: '20px', fontFamily:'untitled_sansregular_regular' }}>
                { `${ item?.details?.unitPrice ?? 0 } USD` }
              </Typography>
            </Box>
          )}
        </>
      )}

      {isOrder && (
        <p className={styles.contText}>
          {moment(purchaseDate)?.format("DD MMM, YYYY h:mm a")}
        </p>
      )}

      {item?.saleType === 'Auction' && <Typography className={styles.reserved}>{auctionType.status}</Typography>}

      {/* {saleStage === "during" && item?.saleType !== 'Auction'
        ? !isOrder &&
        !isWallet &&
        (isSoldOut ? (
          <p className={styles.reserved}>Sold</p>
        ) : isReserved || item?.details?.totalAvailableUnits === 0 ? (
          <p className={styles.reserved}>Reserved</p>
        ) : saleStage === "during" ? (
          <p className={styles.reserved}>Inquire</p>
        ) : (
          item && item?.saleType !== 'Auction' && <SaleTag item={item} />
        ))
        : item && item?.saleType !== 'Auction' && <SaleTag item={item} />} */}

      {item?.saleType !== 'Auction' && !isOrder && (
        <p className={styles.reserved}>{buyNowType?.text}</p>
      )}

      {isWallet ? (
        <ButtonComponent
          text={
            // saleStage === "during" && !isReserved && !isSoldOut
            //   ? "Inquire"
            //   :
            "View Details"
          }
          variant="outlined"
          cls="primary"
          handleClick={(e: any) => {
            fbq.event('View Details', {
              userEmail: user?.email,
              productId: item?.id || itemId,
              productName: item?.name,
              saleType: item?.saleType,
            });
            localStorage.setItem("breadcrumbs", JSON.stringify(breadCrumbsLabel));
            // if (saleStage === "during" && !isReserved && !isSoldOut) {
            //   window.location.href = "mailto:verso@pacegallery.com";
            //   e.preventDefault();
            // } else {
            if (deatilsForTransfer) {
              localStorage.setItem(
                "transferDetails",
                JSON.stringify(deatilsForTransfer)
              );
            }
            router.push(
              {
                pathname: `/project/nft/${item?.id || itemId}`,
                query: { wallet: true },
              },
              `/project/nft/${item?.id || itemId}`
            );
            // }
          }}
        />
      ) : (
        !isOrder && (
          <ButtonComponent
            text={item?.saleType === 'Auction' ? auctionType.buttonText : buyNowType.buttonName}
            variant="outlined"
            cls="primary"
            handleClick={(e: any) => {
              fbq.event('View Details', {
                userEmail: user?.email,
                productId: item?.id || itemId,
                productName: item?.name,
                saleType: item?.saleType,
              });
              // if (saleStage === "during" && !isReserved && !isSoldOut) {
              //   window.location.href = "mailto:verso@pacegallery.com";
              // } else {
              localStorage.setItem("breadcrumbs", JSON.stringify(breadCrumbsLabel));
              router.push(
                {
                  pathname: `/project/nft/${item?.id || itemId}`,
                  query: { order: true },
                },
                `/project/nft/${item?.id || itemId}`
              );
              // }
            }}
          />
        )
      )}
    </div>
    </div>
  );
};

export default NFTItem;
